import React from 'react';
import FormatPage from '../../../components/atoms/FormatPage/FormatPage';
import FitOnePage from '../../../components/atoms/FitOnePage/FitOnePage';
import PageOrientation from '../../../components/atoms/PageOrientation/PageOrientation';
import TrimParent from '../../../components/atoms/TrimParent/TrimParent';
import MakeAvailableForIpad from '../../../components/atoms/MakeAvailableForIpad/MakeAvailableForIpad';

import LabelSystem from '../../../../DesignSystem/LabelSystem';
export default function GeneralTab({
  t,
  formatExport,
  setFormatExport,
  isFitOnePage,
  setIsFitOnePage,
  pageOrientation,
  setPageOrientation,
  isTrimParent,
  setIsTrimParent,
  makeAvailableForIpad,
  setMakeAvailableForIpad
}) {
  return (
    <div className="export-pdf-general-tab">
      <section>
        <h5>{t('export_pdf_modal.page_options')}</h5>
        <div className="export-pdf-general-tab__page-options">
          <div className="export-pdf-general-tab__dropdown">
            <LabelSystem theme="dark">
              {t('export_pdf_modal.select_format')}
            </LabelSystem>
            <FormatPage
              t={t}
              formatExport={formatExport}
              setFormatExport={setFormatExport}
              setIsFitOnePage={setIsFitOnePage}
              setPageOrientation={setPageOrientation}
            />
          </div>

          <div className="export-pdf-general-tab__dropdown">
            <LabelSystem theme="dark">
              {t('export_pdf_modal.orientation')}
            </LabelSystem>
            <PageOrientation
              t={t}
              formatExport={formatExport}
              pageOrientation={pageOrientation}
              setPageOrientation={setPageOrientation}
            />
          </div>
        </div>

        <FitOnePage
          t={t}
          formatExport={formatExport}
          isFitOnePage={isFitOnePage}
          setIsFitOnePage={setIsFitOnePage}
        />
      </section>

      <section>
        <h5>{t('export_pdf_modal.other_options')}</h5>
        <TrimParent
          t={t}
          isTrimParent={isTrimParent}
          setIsTrimParent={setIsTrimParent}
        />

        <MakeAvailableForIpad
          t={t}
          makeAvailableForIpad={makeAvailableForIpad}
          setMakeAvailableForIpad={setMakeAvailableForIpad}
        />
      </section>
    </div>
  );
}
